/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgAgent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 44 44' {...props}>
    <g mask='url(#svg_agent_base_mask)'>
      <use href='#svg_agent_icon' />
    </g>
    <g filter='url(#svg_agent_filter0)' mask='url(#svg_agent_mask0)'>
      <use href='#svg_agent_icon' />
    </g>
    <g filter='url(#svg_agent_filter1)' mask='url(#svg_agent_mask1)'>
      <use href='#svg_agent_icon' />
    </g>
    <g filter='url(#svg_agent_filter2)' mask='url(#svg_agent_mask2)'>
      <use href='#svg_agent_icon' />
    </g>
    <g filter='url(#svg_agent_filter3)' mask='url(#svg_agent_mask3)'>
      <use href='#svg_agent_icon' />
    </g>
    <g filter='url(#svg_agent_filter4)' mask='url(#svg_agent_mask4)'>
      <use href='#svg_agent_icon' />
    </g>
    <defs>
      <symbol id='svg_agent_icon'>
        <g filter='url(#svg_agent_base_filter)' mask='url(#svg_agent_opacity_mask)'>
          <circle cx={22} cy={22} r={12} fill='currentColor' />
        </g>
      </symbol>
      <mask id='svg_agent_opacity_mask' maskContentUnits='objectBoundingBox'>
        <path fill='url(#svg_agent_base_gradient)' d='M0 0h1v1H0z' />
      </mask>
      <linearGradient id='svg_agent_base_gradient' gradientTransform='rotate(90)'>
        <stop offset={0.6} stopColor='#fff' />
        <stop offset={0.8} stopColor='#fff' stopOpacity={0.3} />
        <stop offset={1} stopColor='#fff' stopOpacity={0.1} />
      </linearGradient>
      <filter
        id='svg_agent_base_filter'
        width={44}
        height={44}
        x={0}
        y={0}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feBlend in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx={-3.5} dy={1} />
        <feGaussianBlur stdDeviation={0.75} />
        <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.64 0' />
        <feBlend in2='shape' mode='overlay' result='effect1_innerShadow_8078_39' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset dx={3.5} dy={1} />
        <feGaussianBlur stdDeviation={0.75} />
        <feComposite in2='hardAlpha' k2={-1} k3={1} operator='arithmetic' />
        <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0' />
        <feBlend
          in2='effect1_innerShadow_8078_39'
          mode='overlay'
          result='effect2_innerShadow_8078_39'
        />
      </filter>
      <mask id='svg_agent_base_mask'>
        <path fill='#fff' d='M0 0h44v23H0z' />
      </mask>
      <linearGradient id='svg_agent_gradient0' gradientTransform='rotate(90)'>
        <stop offset={0} />
        <stop offset={0.03} stopColor='#fff' />
        <stop offset={0.1} stopColor='#fff' />
        <stop offset={0.2} />
      </linearGradient>
      <mask
        id='svg_agent_mask0'
        width={44}
        height={44}
        x={-10}
        y={-10}
        maskContentUnits='userSpaceOnUse'
      >
        <path fill='url(#svg_agent_gradient0)' d='M0 21h44v23H0z' />
      </mask>
      <filter id='svg_agent_filter0' filterUnits='userSpaceOnUse'>
        <feGaussianBlur stdDeviation={0.1} />
      </filter>
      <linearGradient id='svg_agent_gradient1' gradientTransform='rotate(90)'>
        <stop offset={0} />
        <stop offset={0.05} stopColor='#fff' />
        <stop offset={0.15} stopColor='#fff' />
        <stop offset={0.4} />
      </linearGradient>
      <mask
        id='svg_agent_mask1'
        width={44}
        height={44}
        x={-10}
        y={-10}
        maskContentUnits='userSpaceOnUse'
      >
        <path fill='url(#svg_agent_gradient1)' d='M0 21h44v23H0z' />
      </mask>
      <filter id='svg_agent_filter1' filterUnits='userSpaceOnUse'>
        <feGaussianBlur stdDeviation={1} />
      </filter>
      <linearGradient id='svg_agent_gradient2' gradientTransform='rotate(90)'>
        <stop offset={0} />
        <stop offset={0.2} stopColor='#fff' />
        <stop offset={0.4} stopColor='#fff' />
        <stop offset={0.6} />
      </linearGradient>
      <mask
        id='svg_agent_mask2'
        width={44}
        height={44}
        x={-10}
        y={-10}
        maskContentUnits='userSpaceOnUse'
      >
        <path fill='url(#svg_agent_gradient2)' d='M0 21h44v23H0z' />
      </mask>
      <filter id='svg_agent_filter2' filterUnits='userSpaceOnUse'>
        <feGaussianBlur stdDeviation={2} />
      </filter>
      <linearGradient id='svg_agent_gradient3' gradientTransform='rotate(90)'>
        <stop offset={0.2} />
        <stop offset={0.41} stopColor='#fff' />
        <stop offset={0.7} stopColor='#fff' />
        <stop offset={0.8} />
      </linearGradient>
      <mask
        id='svg_agent_mask3'
        width={44}
        height={44}
        x={-10}
        y={-10}
        maskContentUnits='userSpaceOnUse'
      >
        <path fill='url(#svg_agent_gradient3)' d='M0 21h44v23H0z' />
      </mask>
      <filter id='svg_agent_filter3' filterUnits='userSpaceOnUse'>
        <feGaussianBlur stdDeviation={3} />
      </filter>
      <linearGradient id='svg_agent_gradient4' gradientTransform='rotate(90)'>
        <stop offset={0.4} />
        <stop offset={0.6} stopColor='#fff' />
        <stop offset={0.9} stopColor='#fff' />
        <stop offset={1} />
      </linearGradient>
      <mask
        id='svg_agent_mask4'
        width={44}
        height={44}
        x={-10}
        y={-10}
        maskContentUnits='userSpaceOnUse'
      >
        <path fill='url(#svg_agent_gradient4)' d='M0 21h44v23H0z' />
      </mask>
      <filter id='svg_agent_filter4' filterUnits='userSpaceOnUse'>
        <feGaussianBlur stdDeviation={4} />
      </filter>
    </defs>
  </svg>
)
export default SvgAgent
